module.exports = __webpack_public_path__ + "img/system_zasilania_wody_04.1ed09e47.jpg";